import { Box, IconButton, Paper, Stack, styled, TextField, Typography } from "@mui/material";

export const ChatWrapper = styled("div")({});

export const ChatContainer = styled(Box)(({ theme }) => ({
  height: 500,
  maxWidth: 800,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.default,
}));

export const MessagesArea = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const BubbleWrapper = styled(Stack)<{ align: string }>(({ align }) => ({
  alignSelf: align,
  maxWidth: "70%",
}));

export const SenderLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  paddingLeft: theme.spacing(0.5), // 4px
}));

export const BubblePaper = styled(Paper)<{
  bgcolorValue: string;
  textcolor: string;
}>(({ bgcolorValue, textcolor, theme }) => ({
  backgroundColor: bgcolorValue,
  color: textcolor,
  borderRadius: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
}));

export const Timestamp = styled(Typography)<{ align: string }>(({ align, theme }) => ({
  color: theme.palette.text.placeholder,
  alignSelf: align,
}));

export const FileUploadHighlight = styled("span")(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

export const MessageBoxContainer = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.strokeColor.secondary}`,
  padding: theme.spacing(2),
  display: "flex",
  gap: theme.spacing(1),
  alignItems: "center",
  position: "relative",
}));

export const MessageInput = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 9999,
    paddingRight: theme.spacing(1),
  },
}));

export const SendButton = styled(IconButton)(({ theme }) => ({
  "backgroundColor": theme.palette.primary.main,
  "color": theme.palette.text.white,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));
